import { render, staticRenderFns } from "./WinnerPrizeModal.vue?vue&type=template&id=4576dbe0&scoped=true"
import script from "./WinnerPrizeModal.vue?vue&type=script&lang=js"
export * from "./WinnerPrizeModal.vue?vue&type=script&lang=js"
import style0 from "./WinnerPrizeModal.vue?vue&type=style&index=0&id=4576dbe0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4576dbe0",
  null
  
)

export default component.exports